import DashboardService from "@/src/api/DashboardService.js";
import AuthPermissionService from "@/src/api/AuthPermissionService.js";
import store from "@/src/store/index.js";
import eventBus from "@/src/utils/eventBus.js";
import { isABACEnabled } from "@/src/utils/dynamicFormUtils.js";

export const fetchABACPolicies = async () => {
  await store.dispatch("rbac/fetchPermissions");
  eventBus.emit("permissions-updated");
};

export const fetchPermissions = async () => {
  if (isABACEnabled()) {
    return fetchABACPolicies();
  }

  try {
    const response = await DashboardService.fetchUserPermissions();

    if (response?.success) {
      localStorage.setItem(
        "userPermissions",
        JSON.stringify(response.permissions)
      );

      if (response.role_id) {
        localStorage.setItem("userRoleId", response.role_id);
      }

      await store.dispatch("rbac/fetchPermissions");
      eventBus.emit("permissions-updated");
    }
  } catch (error) {
    console.error("Error fetching permissions:", error);
  }
};

export const hasAdminPermission = () => {
  const permissions = JSON.parse(
    localStorage.getItem("userPermissions") || "[]"
  );
  return permissions?.includes("admin_workspace");
};
